const cable = ActionCable.createConsumer();
export default cable;
